<template>
  <div id="device-bg-main">
    <timer />
    <cost-shift-page />
  </div>
</template>

  <script>
  import costShiftPage from '../components/costShiftPage.vue';
  import timer from '../components/Timer.vue';
      export default {
          name: 'Home',
          components: {
            costShiftPage,
            timer,
          },
        };
      </script>
